<!-- <router-outlet></router-outlet> -->
<div id="all" class="fullHD" *ngIf="datas" (click)="onClick()" (document:keydown)="onKey($event)" [class.grid6]="grid6">
  <div *ngIf="!isVP && current=='video' && currentVideo" id="video" class="fullHD" (click)="onVideoClick()">
    <video #video autoplay [src]="base+datasName+'/videos/'+currentVideo" class="fullHD" (ended)="onVideoEnded($event)" [attr.loop]="loop ? 'loop' : null"></video>
    <!-- <video #video autoplay [src]="base+datasName+'/files/'+datas.video" class="fullHD" [poster]="base+'files/'+getPoster(datas.video)" (ended)="onVideoEnded($event)"></video> -->
    <!-- <div class="progressBar"><div class="progressingBar" [style.backgroundColor]="datas.color" [style.width]="videoProgress+'%'"></div></div> -->
  </div>
  <div id="splash" *ngIf="current == 'splash'" class="suburban fullHD" [class.show]="true" (click)="onSplashClick()">

    <div class="header">
      <h1><span [innerHTML]="datas.title"></span></h1>
      <h2><span [innerHTML]="datas.baseline"></span></h2>
    </div>

    <div class="menu">
      <div class="item" *ngFor="let video of videosTab">
        <a (click)="onPlay(video)" [style.backgroundImage]="bgImage(video.image)" [title]="video.image">
          <span *ngIf="video.title || video.baseline" class="legend">
            <span class="title" *ngIf="video.title" [innerHTML]="video.title"></span>
            <span class="baseline" *ngIf="video.baseline" [innerHTML]="video.baseline"></span>
            <span class="puce" [style.backgroundColor]="espace?.color">&gt;</span>
          </span>
        </a>
      </div>
    </div>
  </div>
  <div id="debug" [innerHTML]="debugTxt" *ngIf="debug"></div>
</div>
